import React, { useCallback, useState } from 'react'

import { TabSystem } from './TabSystem'
import { TabAutomation } from './TabAutomation'
import { TabFunctionality } from './TabFunctionality'
import { TabModules } from './TabModules'

enum Tabs {
    SYSTEM = 'О системе',
    AUTOMATION = 'Автоматизация',
    FUNCTIONALITY = 'Функционал',
    MODULES = 'Модули',
}

export const AboutSection: React.FC = () => {
    const [activeTab, setActiveTab] = useState(Tabs.SYSTEM)

    const renderContent = useCallback((tab: Tabs) => {
        switch (tab) {
            case Tabs.AUTOMATION:
                return <TabAutomation />
            case Tabs.FUNCTIONALITY:
                return <TabFunctionality />
            case Tabs.MODULES:
                return <TabModules />
            default:
                return <TabSystem />
        }
    }, [])

    return (
        <div className="flex px-4 py-10 justify-center bg-[#181818] rounded-t-3xl">
            <div className="flex flex-col w-full lg:w-[940px] gap-4 items-center">
                <h1 className="font-bold text-white text-2xl">
                    О системе NOXSYS
                </h1>
                <ul className="grid grid-cols-2 md:flex md:flex-row gap-4 text-white">
                    {Object.entries(Tabs).map(([key, value]) => (
                        <li
                            key={key}
                            className={
                                'tab_item ' +
                                (activeTab == value
                                    ? 'bg-[#407bff]'
                                    : 'bg-[#262427]')
                            }
                            onClick={() => setActiveTab(value)}
                        >
                            {value}
                        </li>
                    ))}
                </ul>
                <div>{renderContent(activeTab)}</div>
            </div>
        </div>
    )
}
